import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import marketingLeadsRoutes from './marketingLeads/routes';
import AddShopCustomerWrapper from './addCustomer/addShopCustomerWrapper';
import ShopUserCustomersWrapper from '../wrappers/shopUserCustomersWrapper';
import ShopUserEditCustomerWrapper from '../wrappers/shopUserEditCustomerWrapper';
import AddBarberCustomerWrapper from '../../barber/wrappers/addBarberCustomerWrapper';
import BarberCustomersWrapper from '../../barber/wrappers/barberCustomersWrapper';
import BarberUserEditCustomerWrapper from '../../barber/wrappers/barberUserEditCustomerWrapper';
import * as hooks from '../../auth/routerHooks';
import RetentionReport from '../wrappers/shopUserRetentionReportContainer';
import Duplicates from './duplicateRecords';
import BrandUserEditCustomerWrapper from '../../brand/wrappers/brandUserEditCustomerWrapper';
import AddBrandCustomerWrapper from '../../brand/wrappers/addBrandCustomerWrapper';
import BrandCustomersWrapper from '../../brand/wrappers/brandCustomersWrapper';
import { FS_FEATURES } from '../../../modules/infra/observability/fullstory';

const ShopRoutes = store => (
  <Route
    path="/customers"
    name="customers"
    onEnter={(...args) => {
      hooks.initFullstoryFeature(FS_FEATURES.CLIENTS)();
      return hooks.requireClientsViewPermission(store)(...args);
    }}
  >
    <IndexRoute component={ShopUserCustomersWrapper} />
    {marketingLeadsRoutes}
    <Route
      path="retention"
      name="reports.retention"
      component={RetentionReport}
    />
    <Route path="add" name="customers.add" component={AddShopCustomerWrapper} />
    <Route path="duplicates" name="customers.duplicates" component={Duplicates}>
      <IndexRoute component={Duplicates} />
      <Route path=":customerId" name="customer.duplicates" component={Duplicates} />
    </Route>
    <Route path=":customerId" name="customers.details" component={ShopUserEditCustomerWrapper} />
  </Route>
);

const BarberRoutes = store => (
  <Route
    path="customers"
    name="customers"
    onEnter={(...args) => {
      hooks.initFullstoryFeature(FS_FEATURES.CLIENTS)();
      return hooks.requireClientsViewPermission(store)(...args);
    }}
  >
    <IndexRoute component={BarberCustomersWrapper} />
    <Route path="add" name="customers.add" component={AddBarberCustomerWrapper} />
    <Route path="duplicates" name="customers.duplicates" component={Duplicates}>
      <IndexRoute component={Duplicates} />
      <Route path=":customerId" name="customer.duplicates" component={Duplicates} />
    </Route>
    <Route path=":customerId" name="customers.details" component={BarberUserEditCustomerWrapper} />
  </Route>
);

const BrandRoutes = store => (
  <Route
    path="customers"
    name="customers"
    onEnter={(...args) => {
      hooks.initFullstoryFeature(FS_FEATURES.CLIENTS)();
      return hooks.requireClientsViewPermission(store)(...args);
    }}
  >
    <IndexRoute component={BrandCustomersWrapper} />
    {marketingLeadsRoutes}
    <Route path="add" name="customers.add" component={AddBrandCustomerWrapper} />
    <Route path="duplicates" name="customers.duplicates" component={Duplicates}>
      <IndexRoute component={Duplicates} />
      <Route path=":customerId" name="customer.duplicates" component={Duplicates} />
    </Route>
    <Route path=":customerId" name="customers.details" component={BrandUserEditCustomerWrapper} />
  </Route>
);

export default {
  ShopRoutes,
  BarberRoutes,
  BrandRoutes,
};
